import React, { useContext, useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Alert, AlertTitle, Box, Container, Link, LinearProgress, Typography } from "@mui/material";
import OrderDetails from "../component/OrderDetails";
import OrderFulfillment from "../component/OrderFulfillment";
import OrderPayment from "../component/OrderPayment";
import bkstApi from "../../common/api";
import OrderInvoices from "../component/OrderInvoices";
import OrderChat from "../component/OrderChat";
import moment from "moment";
import ConfigContext from "../../common/context/ConfigContext";
import { getCustomerFirstNameLastInitial, getCustomerName } from "../../common/util";

export default function Order(props) {
  const ref = useRef(null);
  const siteConfig = useContext(ConfigContext);

  const { orderId } = useParams();
  const [order, setOrder] = useState();

  useEffect(() => {
    bkstApi(`/site/${siteConfig.id}/order/${orderId}`).then((res) => {
      document.title = "Order Details";
      setOrder(res.data);
      ref.current.scrollIntoView();
    });
  }, [orderId]);

  if (!order) {
    return <LinearProgress />;
  } else {
    let showChatWidget = true;
    if (order.status === "completed") {
      // check elapsed time since fulfillment
      const elapsedDaySinceFulfillment = moment().diff(moment(order.fulfillment.date), "days");
      console.log("elapsedDaySinceFulfillment", elapsedDaySinceFulfillment);

      if (elapsedDaySinceFulfillment > 3) {
        showChatWidget = false;

        // check last msg from bakery
        const msgFromBaker = order.customer?.chat?.filter((o) => o.by === "baker") || [];
        const lastMsg = msgFromBaker[msgFromBaker.length - 1];

        if (lastMsg && moment().diff(moment(lastMsg.ts), "days") <= 3) {
          showChatWidget = true;
        }
      }
    }

    return (
      <Container mb={15} maxWidth="md" ref={ref}>
        <Box pt={5} pb={20}>
          <Typography variant="h1" gutterBottom>
            Order for {getCustomerFirstNameLastInitial(order.customer)}
            {" | "}
            {moment(order.fulfillment.date).format("ddd, MMM D, YYYY")}
          </Typography>
          {(order.status === "fulfilled" || order.status === "completed") && (
            <Box my={2}>
              <Alert severity="success">
                <AlertTitle>Your Order has been Completed</AlertTitle>
                We look forward to serving you again
              </Alert>
            </Box>
          )}
          {order.status === "canceled" && (
            <Box my={2}>
              <Alert severity="error">
                <AlertTitle>This Order has been Canceled</AlertTitle>
                We look forward to serving you again
              </Alert>
            </Box>
          )}
          <Box>
            <Box pt={2}>
              <Typography variant="overline" color="textSecondary" component="h2">
                Order Details
              </Typography>
              <OrderDetails order={order} />
            </Box>
            <Box my={6}>
              <OrderFulfillment order={order} />
            </Box>
            {order.invoice && <OrderInvoices data={order.invoice} />}
            <Box my={6}>
              <Typography variant="overline" color="textSecondary" component="h2">
                Payment Details
              </Typography>
              <OrderPayment order={order} />
            </Box>
            <Box mt={6} mb={2}>
              <Typography variant="body1" color="textSecondary"></Typography>
              This order was confirmed at{" "}
              {moment(order.ts._seconds * 1000).format("ddd, MMM DD, YYYY h:mm a")}. For help with
              this order, please send a message or call the store for assistance. For cancellations
              & refunds, please refer to the{" "}
              <Link underline="always" href="/store-policy">
                Store Policies
              </Link>{" "}
              .
            </Box>
            {showChatWidget && (
              <Box>
                <OrderChat
                  orderId={orderId}
                  name={order.baker.name}
                  chat={order.customer.chat}
                  color="primary"
                  variant="contained"
                  fullWidth
                />
              </Box>
            )}
          </Box>
        </Box>
      </Container>
    );
  }
}
